import cultureService from './cultureService'
import payment from './paymentService'
import cookieService from './cookieService'
import trackingService from '~/api/trackingService'

export default ($axios) => {
  const cookies = cookieService()
  return {
    cookies,
    tracking: trackingService($axios, process.env.API_URL),
    culture: cultureService($axios, cookies, process.env.API_URL),
    payment: payment($axios, process.env.API_URL),
  }
}
